import apiClient from './client';

type GetSubscriptionResponse = {
  success: boolean;
  data: {
    is_subscribed: boolean;
  } | null;
  error: string | null;
};

export async function getSubscription(): Promise<GetSubscriptionResponse> {
  const response = await apiClient.get('/subscription');
  return response.data;
}
